module.exports = __webpack_public_path__ + "img/pt_seguroportatil.d69e8188.png";